

<section style="overflow-y: scroll;height: 100%;">
  <div class="wrapper">
  <!-- <label class="diagnostic-label"  style="width: 90%;">Key Pathology/Biology features</label> -->
  <button type="button" class="add-boutton fa fa-search-plus" style="left: 70%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25%;  font-weight: normal;" name="Addfont" (click)="ZoomIn()"></button>
  <button type="button" class="add-boutton fa fa fa-search-minus" style="left: 74%;width: 4%;background-color: rgb(255, 255, 255); color: rgb(0, 0, 0);border-radius: 25% ;font-weight: normal;" name="Munesfont" (click)="ZoomOut()"></button>
  <button type="button" class="add-boutton" [disabled]="disablepharnacy" style="left: 83%" name="Add" (click)="openDialog()">Add</button>
  </div>


<BR>
<BR>
 <table style="left: 5%;width: 90%;">
  <tr *ngFor="let item of DiganosiseList; let i = index" style="font-size: {{wk_fontsize}};text-align: left;">
    <td>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <label style="font-weight: bold;color: rgb(0, 0, 118);">{{item.digdate}} {{item.username}}   </label>      <label style="font-weight: bold;color: rgb(0, 0, 118);" for="">({{diglocationtext[i]}})</label>
        </div>
        <div>
          <button class="fa fa-pencil" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: green;" matTooltip="Edit" name="Add" (click)="EditDiganosis(item)"></button>
          <button class="fa fa-trash" [disabled]="disablepharnacy" style="border-style: none; background-color: white; color: red;" matTooltip="Delete" name="Delete" (click)="MessegeDelete(item)"></button>
        </div>
      </div>
      <label  >{{item.cancerid}}   {{wk_SubCancer_Name[i]}}</label>
      <BR>


        <BR>
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_tissue[i]">♦{{item.tissuehed}} :</label> <label >{{item.tissue}}</label>  <label style="font-weight: bold;" [hidden] = "wk_Heddin_histology[i]">♦{{item.histologyhed}} :</label>  <label [hidden] = "wk_Heddin_histology[i]">{{item.histology}}</label> 
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_er[i]">♦{{item.erhed}} :</label><label [hidden] = "wk_Heddin_er[i]">{{item.er}}</label> 
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_pr[i]">♦{{item.prhed}} :</label><label [hidden] = "wk_Heddin_pr[i]">{{item.pr}}</label> 
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_her2ihs[i]">♦{{item.her2ihshed}} :</label> <label [hidden] = "wk_Heddin_her2ihs[i]">{{item.her2ihs}}</label> 
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_her2fish[i]">♦{{item.her2fishhed}} :</label>  <label [hidden] = "wk_Heddin_her2fish[i]">{{item.her2fish}}</label> 
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_ki67[i]">♦{{item.ki67hed}} :</label> <label [hidden] = "wk_Heddin_ki67[i]">{{item.ki67}}{{ki67perc[i]}}</label>
        <BR>

       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_pdl1[i]">♦{{item.pdl1hed}} :</label> <label [hidden] = "wk_Heddin_pdl1[i]">{{item.pdl1}}</label>   
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_brca1[i]">♦{{item.brca1hed}} :</label> <label [hidden] = "wk_Heddin_brca1[i]">{{item.brca1}}</label>   
       <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_brca2[i]">♦{{item.brca2hed}} :</label> <label [hidden] = "wk_Heddin_brca2[i]">{{item.brca2}}</label>   
      <BR>
       <label style="font-weight: bold;width: 10%;"[hidden] = "wk_Heddin_digstage[i]">♦{{item.digstagehed}} :</label> <label [hidden] = "wk_Heddin_digstage[i]">{{item.digstage}}   </label>
       <label style="font-weight: bold;width: 10%;"[hidden] = "wk_Heddin_grade[i]">♦{{item.grade}} :</label><label [hidden] = "wk_Heddin_grade[i]">{{item.grade}}</label>
      <BR>
      <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_digt[i]">♦{{item.digthed}} :</label> <label [hidden] = "wk_Heddin_digt[i]">{{item.digt}}</label>   
      <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_dign[i]">♦{{item.dignhed}} :</label> <label [hidden] = "wk_Heddin_dign[i]">{{item.dign}}</label>   
      <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_digm[i]">♦{{item.digmhed}} :</label> <label [hidden] = "wk_Heddin_digm[i]">{{item.digm}}</label>   

      <label [hidden] = "wk_Heddin_her2[i]">♦{{item.her2hed}} :{{item.her2}}</label>
       <BR [hidden] = "wk_Heddin_her2[i]">
      <label style="font-weight: bold;width: 10%;" [hidden] = "wk_Heddin_msi[i]">♦{{item.msihed}} : </label><label  [hidden] = "wk_Heddin_msi[i]">{{item.msi}}</label>
      <BR [hidden] = "wk_Heddin_msi[i]">
      <label [hidden] = "wk_Heddin_egfr[i]">♦{{item.egfrhed}} :{{item.egfr}}</label>
      <BR [hidden] = "wk_Heddin_egfr[i]">
      <label [hidden] = "wk_Heddin_alk[i]">♦{{item.alkhed}} :{{item.alk}}</label>
      <BR [hidden] = "wk_Heddin_alk[i]">

      <label [hidden] = "wk_Heddin_kras[i]">♦{{item.krashed}} :{{item.kras}}</label>
      <BR [hidden] = "wk_Heddin_kras[i]">
      <label [hidden] = "wk_Heddin_braf[i]">♦{{item.brafhed}} :{{item.braf}}</label>
      <BR [hidden] = "wk_Heddin_braf[i]">
      <label [hidden] = "wk_Heddin_hrd[i]">♦{{item.hrdhed}} :{{item.hrd}}</label>
      <BR [hidden] = "wk_Heddin_hrd[i]">
      <label [hidden] = "wk_Heddin_gscore[i]">♦{{item.gscorehed}} :{{item.gscore}}</label>
      <BR [hidden] = "wk_Heddin_gscore[i]">
      <label [hidden] = "wk_Heddin_nfeature[i]">♦{{item.nfeaturehed}} :{{item.nfeature}}</label>
      <BR [hidden] = "wk_Heddin_nfeature[i]">

      <BR [hidden] = "wk_Heddin_her2fish[i]">
      <label [hidden] = "wk_Heddin_hpv[i]">{{item.hpv}}%</label>
      <label [hidden] = "wk_Heddin_hpv[i]">{{item.digmain}}</label>
      <BR>
      <label style="font-weight: bold;width: 10%;">Others : </label>
      <angular-editor [(ngModel)]="item.digmain" [config]="editorConfigNoToolbar" style="border: none !important; box-shadow: none !important;">
      </angular-editor>
      <br>
      <br>
    </td>
  </tr>
</table>
</section>


